// @flow
import { EVENT_TIMEZONE_OPTIONS } from "../constants";

// Exact HERE-to-API mappings; unsupported zones remain unset.
const IANA_TO_EVENT_TIMEZONE: { [string]: string } = {
  // Eastern
  "America/New_York": "US/Eastern",
  "America/Detroit": "US/Eastern",
  "America/Kentucky/Louisville": "US/Eastern",
  "America/Kentucky/Monticello": "US/Eastern",
  "America/Indiana/Indianapolis": "US/Eastern",
  "America/Indiana/Vincennes": "US/Eastern",
  "America/Indiana/Winamac": "US/Eastern",
  "America/Indiana/Marengo": "US/Eastern",
  "America/Indiana/Petersburg": "US/Eastern",
  "America/Indiana/Vevay": "US/Eastern",
  // Central
  "America/Chicago": "US/Central",
  "America/Indiana/Knox": "US/Central",
  "America/Indiana/Tell_City": "US/Central",
  "America/Menominee": "US/Central",
  "America/North_Dakota/Center": "US/Central",
  "America/North_Dakota/New_Salem": "US/Central",
  "America/North_Dakota/Beulah": "US/Central",
  // Mountain
  "America/Denver": "US/Mountain",
  "America/Boise": "US/Mountain",
  // Arizona (no DST)
  "America/Phoenix": "US/Arizona",
  // Pacific
  "America/Los_Angeles": "America/Los_Angeles",
  // Alaska
  "America/Anchorage": "US/Alaska",
  "America/Juneau": "US/Alaska",
  "America/Sitka": "US/Alaska",
  "America/Metlakatla": "US/Alaska",
  "America/Yakutat": "US/Alaska",
  "America/Nome": "US/Alaska",
  // Hawaii
  "Pacific/Honolulu": "Pacific/Honolulu",
};

export const isSupportedEventTimezone = (value: ?string): boolean =>
  !!value &&
  EVENT_TIMEZONE_OPTIONS.some(
    (option: { value: string, label: string }): boolean =>
      option.value === value
  );

export const toEventTimezone = (ianaName: ?string): ?string => {
  if (!ianaName) {
    return null;
  }

  if (isSupportedEventTimezone(ianaName)) {
    return ianaName;
  }

  return IANA_TO_EVENT_TIMEZONE[ianaName] || null;
};
